module.exports = __webpack_public_path__ + "static/media/webflow.469a58f2.svg";